  import { call, put, takeLatest } from "redux-saga/effects";
  import axiosInstance from "pages/Utility/axiosInstance";
  import * as types from "./actionTypes";
  import {
    fetchAssignmentsSuccess,
    fetchAssignmentsFailure,
    fetchAssignmentDetailsSuccess,
    fetchAssignmentDetailsFailure,
    deleteAssignmentSuccess,
    deleteAssignmentFailure,
  } from "./actions";

  // ======================
  // Fetch All Assignments
  // ======================
  const fetchAssignmentsAPI = async (params) => {
    const response = await axiosInstance.get("V1/assignments", { params });
    return response.data;
  };

  function* fetchAssignmentsSaga(action) {
    try {
      const response = yield call(fetchAssignmentsAPI, action.payload);
      yield put(fetchAssignmentsSuccess(response));
    } catch (error) {
      yield put(fetchAssignmentsFailure(error.message));
    }
  }

  // ======================
  // Fetch Single Assignment Details
  // ======================
  const fetchAssignmentDetailsAPI = async (id, params = {}) => {
    const response = await axiosInstance.get(`V1/assignments/${id}`, { params });
    return response.data;
  };
  function* fetchAssignmentDetailsSaga(action) {
    try {
      const { id, params = {} } = action.payload; //  supports pagination, status, search
      const response = yield call(fetchAssignmentDetailsAPI, id, params);
      yield put(fetchAssignmentDetailsSuccess(response));
    } catch (error) {
      yield put(fetchAssignmentDetailsFailure(error.message));
    }
  }

  // ======================
  // Delete Assignment
  // ======================
  const deleteAssignmentAPI = async (id) => {
    const response = await axiosInstance.delete(`V1/assignments/${id}`);
    return response.data;
  };

  function* deleteAssignmentSaga(action) {
    try {
      const response = yield call(deleteAssignmentAPI, action.payload);
      yield put(deleteAssignmentSuccess(response));
    } catch (error) {
      yield put(deleteAssignmentFailure(error.message));
    }
  }

  // ======================
  // Watchers
  // ======================
  export default function* assignmentSaga() {
    yield takeLatest(types.FETCH_ASSIGNMENTS_REQUEST, fetchAssignmentsSaga);
    yield takeLatest(types.FETCH_ASSIGNMENT_DETAILS_REQUEST, fetchAssignmentDetailsSaga);
    yield takeLatest(types.DELETE_ASSIGNMENT_REQUEST, deleteAssignmentSaga);
  }
